import * as Yup from "yup";

import { CreateAndUpdatePortfolioStatment, CreateAndUpdatePortfolioStatmentVariables } from "_graphql/mutation/__generated__/CreateAndUpdatePortfolioStatment";

import { LocationGenerics } from "router/location";
import { Modal } from "components";
import {
  ProfitStatementCommisionForm,
} from "components/forms";
import _ from "lodash";
import {
  createAndUpdatePortfolioStatmentAndProfitCommission,
} from "_graphql/visal/mutations/treaty";
import moment from "moment";
import toast from "react-hot-toast";
import { useEffect } from "react";
import { useFormik } from "formik";
import { useMatch } from "react-location";
import { useMutation } from "@apollo/client";
import { useTreaty } from "hooks/data/use-treaties";
import { wrapClick } from "utils";

export const validationSchema = Yup.object().shape({
  // treaty_proportional_detail_id: Yup.string().required("Treaty Proportional Detail ID is required"),
  overall_gross_premium: Yup.number()
    .min(0, "Number must be greater than 0")
    .typeError("Should be a number")
    .required("Overall Gross Premium is required"),
  losses: Yup.number()
    .min(0, "Number must be greater than 0")
    .typeError("Should be a number")
    .required("Losses are required"),
  prev_year_configuration: Yup.object().shape({
    outgoing_premium_portfolio: Yup.number()
      .min(0, "Number must be greater than 0")
      .typeError("Should be a number")
      .required("Outgoing Premium Portfolio is required"),
    outgoing_loss_portfolio: Yup.number()
      .min(0, "Number must be greater than 0")
      .typeError("Should be a number")
      .required("Outgoing Loss Portfolio is required"),
  }),
  known_losses: Yup.object().shape({
    date: Yup.date().required("Date is required"),
    loss: Yup.number()
      .min(0, "Number must be greater than 0")
      .typeError("Should be a number")
      .required("Loss is required"),
  }),
});

export default function ProfitStatementCommisionContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const { params } = useMatch<LocationGenerics>();
  const { loading: fetching, treaty } = useTreaty({
    treatyId: params.treaty || "",
  });
  const [create, { loading }] = useMutation<
    CreateAndUpdatePortfolioStatment,
    CreateAndUpdatePortfolioStatmentVariables
  >(createAndUpdatePortfolioStatmentAndProfitCommission, {
    refetchQueries: ["Treaty", "GetTreatyBrokersParticipants"],
  });
  const isSpecialProgram = /fire|general accident/g.test(
    treaty?.treaty_program?.treaty_name?.toLowerCase() || ""
  );

  const form = useFormik<CreateAndUpdatePortfolioStatmentVariables>({
    initialValues: {
      treaty_proportional_detail_id: treaty?.treaty_proportional_detail?.treaty_proportional_detail_id || "",
      overall_gross_premium: null,
      losses: null,
      prev_year_configuration: {
        outgoing_premium_portfolio: null,
        outgoing_loss_portfolio: null,
      },
      known_losses: {
        date: null,
        loss: null
      }
    },
    validationSchema: validationSchema,
    onSubmit: (variables) => {
      create({ variables: variables }).then(res => {
        if (res.data?.createAndUpdatePortfolioStatmentAndProfitCommission) {
          toast.success("Profit commission and portfolio statement saved successfully");
          setOpen(false);
          // refetch?.();
        } else {
          toast.error("Failed to save profit commission and portfolio statement");
        }
      }).catch(err => {
        toast.error("Failed to save profit commission and portfolio statement");
      })
    },
    onReset: () => {
      setOpen(false);
    },
  });

  useEffect(() => {
    if (treaty) {
      // form.setFieldValue("treaty_proportional_detail_id", treaty?.treaty_proportional_detail?.treaty_proportional_detail_id || "");
      // form.setFieldValue("overall_gross_premium", treaty?.treaty_accounts?.reduce(
      //   (a, b) =>
      //     a +
      //     _.sumBy(
      //       b?.treaty_account_deduction,
      //       "gross_premium"
      //     ),
      //   0
      // ));
      const prev_year_configuration = JSON.parse(
        treaty?.treaty_proportional_detail?.prev_year_configuration || "{}"
      )
      const known_losses = JSON.parse(
        JSON.parse(treaty?.treaty_proportional_detail?.portfolio_entry_compute || "{}")?.known_losses ||
        "{}"
      );
      form.setValues({
        treaty_proportional_detail_id: treaty?.treaty_proportional_detail?.treaty_proportional_detail_id || "",
        overall_gross_premium: treaty?.treaty_accounts?.reduce(
          (a, b) =>
            a +
            _.sumBy(
              b?.treaty_account_deduction,
              "gross_premium"
            ),
          0
        ) || null,
        losses: treaty?.treaty_proportional_detail?.losses_outstanding || 0,
        prev_year_configuration: {
          outgoing_premium_portfolio: prev_year_configuration?.outgoing_premium_portfolio || 0,
          outgoing_loss_portfolio: prev_year_configuration?.outgoing_loss_portfolio || 0,
        },
        known_losses: {
          date: known_losses?.date ? moment(known_losses.date).format("yyyy-MM-DD") : null,
          loss: known_losses?.loss || 0,
        }
      })
    }
  }, [treaty]);

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={fetching}
      title={isSpecialProgram ? "Profit Comm. & Portfolio Stmt" : "Profit Comm."}
      description={isSpecialProgram
        ? "Add profit commission and portfolio statement for this treaty"
        : "Add profit commission for this treaty"}
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={wrapClick(form.handleSubmit)}
          >
            {loading ? "Saving changes..." : "Save changes"}
          </button>
        </>
      )}
    >
      <ProfitStatementCommisionForm form={form} />
    </Modal>
  );
}
